module.exports = __webpack_public_path__ + "img/arrow-right.afc79a37.svg";